import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

import { IRoom } from "src/app/interfaces/room";
import { CoreService } from "./../../base/core";
import { ServiceRoute } from "../../base/service-route";
import { CommonHttpOption } from "../../base/common-http-option";

@Injectable({
  providedIn: "root"
})
export class RoomService {
  constructor(private coreService: CoreService) {}

  list(page: number = 1, pageSize: number = 10): Observable<any> {
    return this.coreService.get(
      ServiceRoute.room.list,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  getRoomListByBranchId(branchId: string): Observable<any> {
    return this.coreService.get(
      ServiceRoute.room.getRoomListByBranchId + branchId,
      new CommonHttpOption().headers
    );
  }

  getById(id: number): Observable<any> {
    return this.coreService.get(
      ServiceRoute.room.getById + id,
      new CommonHttpOption().headers
    );
  }

  add(data: IRoom): Observable<any> {
    return this.coreService.post(
      ServiceRoute.room.add,
      data,
      new CommonHttpOption().headers
    );
  }

  edit(data: IRoom): Observable<any> {
    return this.coreService.put(
      ServiceRoute.room.edit,
      data,
      new CommonHttpOption().headers
    );
  }

  delete(data): Observable<any> {
    return this.coreService.delete(
      ServiceRoute.room.delete,
      new CommonHttpOption().headers,
      data
    );
  }
}
